import {htmlToDOM, Element} from 'html-react-parser';

/**
 * Return an 8 character random key string
 * @returns {string}
 */
const getRandomKey = () => Math.random().toString(36).substr(2, 8);

/**
 * Return the a version of the string with each word's first letter in uppercase
 * @returns {string}
 * @param input
 */
const toPascalCase = (input: string) => {
    return input
        .split(/[^a-z]/i)
        .map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join('');
};

const toFirstLetterUppercase = (input: string) => input.charAt(0).toUpperCase() + input.slice(1);

/**
 * Return base64 encoded string
 * @returns {string}
 * @param input
 */
const base64Encode = (input: string) => {
    if (process.browser) {
        return btoa(input);
    }

    return Buffer.from(input).toString('base64');
};

/**
 * Return base64 decoded string
 * @returns {string}
 * @param input
 */
const base64Decode = (input: string) => {
    if (process.browser) {
        return atob(input);
    }

    return Buffer.from(input, 'base64').toString();
};

/**
 * Return url safe base64 decoded string
 *
 * Take a url safe base64 encoded string and transform it
 * into a standard base64 encoded string before passing it
 * to the base64Decode function.
 *
 * @returns {string}
 * @param input
 */
const base64DecodeUrlSafe = (input: string) => {
    const base64String = (input + '==='.slice((input.length + 3) % 4)).replace(/-/g, '+').replace(/_/g, '/');
    return base64Decode(base64String);
};

/**
 * Parse query string and return as key value store
 *
 * @returns {object}
 * @param queryString
 */
const parseQueryString = (queryString: string): Record<string, string> => {
    const structured: any = {};
    queryString
        .split('&')
        .filter((option) => option.length > 0)
        .map((option) => option.split('='))
        .forEach(([key, value]) => {
            structured[key] = decodeURIComponent(value || key);
        });
    return structured;
};

/**
 * transform any string into a url compatibable slug
 *
 * @param input
 */
const slugify = (input: string) => input.replace(/[^a-z0-9-]/gi, '-').toLowerCase();

const domToText = (input: Element): string => {
    if (input.type === 'text') {
        return input.data || '';
    }

    return input.children?.map(domToText).filter(Boolean).join('') || '';
};

/**
 * strip html tags from a string
 *
 * @param input
 */
const stripHTML = (input: string) => domToText({children: htmlToDOM(input)});

export {getRandomKey, toPascalCase, toFirstLetterUppercase, base64Encode, base64Decode, base64DecodeUrlSafe, parseQueryString, slugify, stripHTML};
